module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-46.e801243c.png";